import { useEffect, useRef, useState } from 'react';
import { CirclePicker, ColorResult } from 'react-color';

interface Props {
  onChangeColor: (color: string) => void;
  onClose: () => void;
}

export default function ColorPickerPanel({ onChangeColor, onClose }: Props) {
  const [color, setColor] = useState<string>('#0099FF');
  const pickerRef = useRef<HTMLDivElement>(null);

  // Close when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const predefinedColors = ['#CBE7CC', '#FFAFA3', '#FFE299', '#A8DAFF'];

  return (
    <div
      ref={pickerRef}
      style={{
        position: 'absolute',
        top: '150px',
        left: '80px',
        zIndex: 1000,
        backgroundColor: '#ffffff',
        padding: '12px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        display: 'inline-block',
      }}
    >
      <CirclePicker
        colors={predefinedColors}
        color={color}
        onChange={(newColor: ColorResult) => {
          setColor(newColor.hex);
          onChangeColor(newColor.hex);
        }}
        width="50px" // optional: make narrower for vertical layout
      />
    </div>
  );
}
